module.exports = __webpack_public_path__ + "static/media/illustration.230d718a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/illustration.svg
// module id = 398
// module chunks = 0